module.exports = __webpack_public_path__ + "static/media/pak-alif.93877464.png";